import {Injectable} from '@angular/core';
import {Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthService} from "./auth.service";
import {map, Observable, take} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(private router: Router, private authService: AuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.authService.user.pipe(
            take(1),
            map(user => {
                if (user) {
                    return true;
                } else {
                    return this.router.createUrlTree(['/login'], {queryParams: {redirectUrl: state.url}});
                }
            })
        );
    }
}